import './App.css';
import {HeartPage} from "./HeartPage";

function App() {
  return (
    <div className="App">
      <HeartPage />
    </div>
  );
}

export default App;
